import React, { useContext } from 'react';
import { Button, Modal } from 'ui';
import CodeOperationsContext from 'contexts/CodeOperationsContext';
import { isCodingVersioningError } from 'utils/versioningErrors';

const LEFT_PADDING = 45;
const MARGIN = 30;

const OutOfDateTranscriptModal = () => {
  const { createExcerptError } = useContext(CodeOperationsContext);
  
  // Check if the error is a coding version mismatch
  const show = isCodingVersioningError(createExcerptError);

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div>
      <Modal show={show}>
        <Modal.Body style={{ padding: 0, margin: 0 }}>
          <div style={{ padding: `30px ${LEFT_PADDING}px`, textAlign: "center" }}>
            <div>
              <h4>
                You're coding an out of date transcript.
              </h4>
            </div>
            <div style={{ marginTop: MARGIN, width: "100%" }}>
              <p>
                To make sure you are coding the most up to date transcript.
                Please refresh and try again.
              </p>
            </div>

            <div style={{ marginTop: MARGIN }}>
              <Button variant="blue" onClick={refreshPage}>
                Refresh Page
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OutOfDateTranscriptModal;